import { Link } from "react-router-dom";
import HeroCarousel from "./HeroCarousel";

const programIcons = {
  "Information Technology": (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="4" width="18" height="14" rx="2" />
      <path d="M8 20h8" />
    </svg>
  ),
  "Film Studies": (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <circle cx="7" cy="9" r="1.6" />
      <circle cx="17" cy="9" r="1.6" />
      <circle cx="7" cy="15" r="1.6" />
      <circle cx="17" cy="15" r="1.6" />
    </svg>
  ),
  "Graphic Design": (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 2l3 7h7l-5.5 4.1L17.8 21 12 16.8 6.2 21l1.3-7.9L2 9h7z" />
    </svg>
  ),
};

export default function Hero({ section, slides = [], programs = [] }) {
  if (!section || section.is_enabled === 0) return null;

  const heroPrograms = programs.slice(0, 3).map((program) => ({
    title: program.name,
    desc: program.heroSummary,
    icon: programIcons[program.name] || programIcons["Graphic Design"],
  }));

  return (
    <section className="hero" id="home" aria-label="Hero section">
      <HeroCarousel slides={slides} />

      <div className="hero__shape hero__shape--1" aria-hidden="true" />
      <div className="hero__shape hero__shape--2" aria-hidden="true" />

      <div className="hero__content">
        <div className="hero__badge animate-fade-up">
          <span className="hero__badge-dot" />
          {section.badge}
        </div>

        <h1 className="hero__headline animate-fade-up" style={{ animationDelay: "0.1s" }}>
          {section.title}
        </h1>

        <p className="hero__subheading animate-fade-up" style={{ animationDelay: "0.2s" }}>
          {section.subtitle}
        </p>

        <div className="hero__ctas animate-fade-up" style={{ animationDelay: "0.3s" }}>
          {section.button_text && section.button_link && (
            <Link to={section.button_link} className="btn btn--accent btn--lg">
              {section.button_text}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          )}
          {section.secondary_button_text && section.secondary_button_link && (
            <Link to={section.secondary_button_link} className="btn btn--primary btn--lg">
              {section.secondary_button_text}
            </Link>
          )}
        </div>

        {heroPrograms.length > 0 && (
          <div className="hero__programs animate-fade-up" style={{ animationDelay: "0.45s" }}>
            {heroPrograms.map((program) => (
              <div key={program.title} className="program-card">
                <span className="program-card__icon" aria-hidden="true">{program.icon}</span>
                <div>
                  <p className="program-card__title">{program.title}</p>
                  <p className="program-card__desc">{program.desc}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="hero__scroll-indicator animate-bounce" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 5v14M5 12l7 7 7-7" />
        </svg>
      </div>
    </section>
  );
}
